const title = '联众宏宇 Microsoft 365支持中心工单系统';

export default function getPageTitle(pageTitle) {
    if (pageTitle) {
        return `${pageTitle} - ${title}`
    }
    return `${title}`
}